(function () {
  window.exoticCardService = {
    get() {
      return axios.get('/api/card/exotic/get.php');
    },
    save(data) {
      return axios.post('/api/card/save.php', { ...data, exotic: 1 });
    },
    toggleActive(data) {
      return axios.post('/api/card/active.php', data);
    },
    link(data) {
      return axios.post('/api/reward/exotic-card/link.php', data);
    },
  };
})();
